<template>
  <div>
    <Nuevo
      :dialog="dialog"
      :Item="itemSelected"
      v-if="dialog"
      @closeDialog="closeDialog"
    />
    <MensajeTransicion
      color="#FA694A"
      :text="mensaje"
      v-if="verAlerta"
      :top="true"
      :bottom="false"
    />

    <v-card class="rounded-lg elevation-3 overflow-hidden">
      <!-- Toolbar Header Principal estilo Cliente / Inspección -->
      <v-toolbar height="58" color="secondary" dark flat class="px-3">
        <div class="d-flex align-center">
          <v-icon left>mdi-currency-usd</v-icon>
          <span class="text-h6 font-weight-medium">
            {{ Titulo || "Tipo de Cambio" }}
          </span>
          <v-chip
            small
            color="white"
            text-color="secondary"
            class="font-weight-bold ml-3 px-3 elevation-1"
            style="font-size: 0.95rem; height: 32px"
          >
            <v-icon left size="18" color="secondary">mdi-counter</v-icon>
            {{ Items ? Items.length : 0 }} Registros
          </v-chip>
        </div>

        <v-spacer></v-spacer>

        <!-- Botón de Ayuda -->
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mx-1 btn-circle-tooltip"
              icon
              dark
              target="_blank"
              :href="global.helpdesk_url + 'tipo_cambio'"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon size="25" color="amber lighten-2">mdi-help-circle-outline</v-icon>
            </v-btn>
          </template>
          <span>¿Necesitas ayuda?</span>
        </v-tooltip>
      </v-toolbar>

      <!-- Sección de Búsqueda y Acciones -->
      <div class="pa-4 pb-2">
        <v-row dense class="align-center mb-1">
          <!-- Búsqueda Rápida -->
          <v-col cols="12" md="6" lg="7">
            <v-text-field
              v-model="search"
              outlined
              dense
              single-line
              hide-details
              prepend-inner-icon="mdi-magnify"
              clearable
              label="Búsqueda rápida"
              placeholder="Buscar por valor, fecha, estado, ID..."
              class="rounded-lg"
            ></v-text-field>
          </v-col>

          <!-- Botones de Acción -->
          <v-col cols="12" md="6" lg="5" class="d-flex align-center justify-end flex-wrap gap-2">
            <!-- Descargar Excel -->
            <v-btn
              v-if="Excel"
              color="success"
              dark
              height="38"
              class="px-4 font-weight-bold elevation-1 text-none rounded-lg mr-2"
              @click="DescargarExcel()"
            >
              <v-icon left size="18">mdi-file-excel</v-icon>
              Descargar Tabla
            </v-btn>

            <!-- Botón Nuevo Tipo de Cambio -->
            <v-btn
              v-if="global._autorizacion_usuario(this.Permisos, this.$route.meta.id, ['2'])"
              color="primary"
              dark
              height="38"
              class="px-4 font-weight-bold elevation-1 text-none rounded-lg"
              @click="nuevoItem()"
            >
              <v-icon left size="20">mdi-plus-circle</v-icon>
              Nuevo Tipo de Cambio
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <!-- Tabla Principal -->
      <div class="table-responsive-wrapper">
        <v-data-table
          dense
          :headers="filteredCabecera"
          :items="Items"
          :items-per-page="10"
          :search="search"
          class="modern-table elevation-0"
          loading-text="Cargando tipo de cambio... Por favor, espere"
          no-data-text="No hay registros de tipo de cambio disponibles"
          :loading="Loading"
          :footer-props="{
            'items-per-page-text': 'Resultados por página:',
            'items-per-page-options': [5, 10, 25, 50],
            'page-text': '{0}-{1} de {2}'
          }"
        >
          <!-- Columna Acciones -->
          <template v-slot:[`item.acciones`]="{ item }">
            <div class="d-flex align-center justify-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    height="26"
                    width="26"
                    color="blue lighten-1"
                    fab
                    x-small
                    dark
                    class="action-btn elevation-1"
                    @click="editarItem(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon x-small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar Tipo de Cambio</span>
              </v-tooltip>
            </div>
          </template>

          <!-- Columna ID -->
          <template v-slot:[`item.id`]="{ item }">
            <span class="font-weight-bold font-mono text--secondary">
              #{{ item.id }}
            </span>
          </template>

          <!-- Columna Valor -->
          <template v-slot:[`item.valor`]="{ item }">
            <v-chip
              small
              color="blue lighten-5"
              text-color="blue darken-3"
              class="font-weight-bold elevation-1"
            >
              <v-icon left x-small color="blue darken-2">mdi-currency-usd</v-icon>
              {{ item.valor }}
            </v-chip>
          </template>

          <!-- Columna Fecha (dia-mes-año) -->
          <template v-slot:[`item.fecha`]="{ item }">
            <div class="d-flex align-center justify-center text-body-2 text--secondary font-mono">
              <v-icon x-small color="grey darken-1" class="mr-1">mdi-calendar</v-icon>
              <span>{{ formatearFecha(item.fecha) }}</span>
            </div>
          </template>

          <!-- Columna Estado -->
          <template v-slot:[`item.estado`]="{ item }">
            <v-chip
              x-small
              :color="item.estado == 1 ? 'green lighten-5' : 'red lighten-5'"
              :text-color="item.estado == 1 ? 'green darken-3' : 'red darken-3'"
              class="font-weight-bold elevation-1"
            >
              <v-icon left x-small :color="item.estado == 1 ? 'green darken-2' : 'red darken-2'">
                {{ item.estado == 1 ? 'mdi-check-circle' : 'mdi-close-circle' }}
              </v-icon>
              {{ item.estado == 1 ? 'Activo' : 'Inactivo' }}
            </v-chip>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Nuevo from "./nuevo.vue";
import exportFromJSON from "export-from-json";
import MensajeTransicion from "../Alerta.vue";
import global from "@/global";

export default {
  props: ["Titulo", "Cabecera", "Items", "Excel", "Crear", "Loading"],
  components: {
    Nuevo,
    MensajeTransicion
  },
  data() {
    return {
      search: "",
      dialog: false,
      itemSelected: {},
      mensaje: "",
      verAlerta: false,
      global: global
    };
  },
  computed: {
    ...mapState("navigation", ["Permisos"]),
    canShowAccionColumn() {
      return global._autorizacion_usuario(this.Permisos, this.$route.meta.id, ["3", "4"]);
    },
    filteredCabecera() {
      return this.Cabecera.filter(
        col => !(col.value === "acciones" && !this.canShowAccionColumn)
      );
    }
  },
  methods: {
    nuevoItem() {
      const fecha = new Date();
      this.itemSelected = {
        id: 0,
        valor: "",
        fecha: this.formatoFecha(fecha, "yyyy-mm-dd")
      };
      this.dialog = true;
    },

    formatoFecha(fecha, formato) {
      const map = {
        dd: fecha.getDate() < 10 ? "0" + fecha.getDate() : fecha.getDate(),
        mm:
          (fecha.getMonth() + 1) / 10 < 1
            ? "0" + (fecha.getMonth() + 1)
            : fecha.getMonth() + 1,
        yyyy: fecha.getFullYear()
      };
      return formato.replace(/dd|mm|yyyy/gi, (matched) => map[matched]);
    },

    formatearFecha(fechaStr) {
      return global.formatearFecha(fechaStr);
    },

    editarItem(item) {
      this.itemSelected = Object.assign({}, item);
      this.dialog = true;
    },

    closeDialog() {
      this.dialog = false;
    },

    DescargarExcel() {
      const data = this.Items;
      const nombreArchivo = "tipo_cambio_" + new Date().toISOString().slice(0, 10);
      const exportType = exportFromJSON.types.xls;
      exportFromJSON({
        data,
        nombreArchivo,
        exportType
      });
    }
  }
};
</script>

<style scoped>
.modern-table ::v-deep thead tr:not(.v-data-table__progress) th {
  background-color: #424242 !important;
  color: #ffffff !important;
  font-size: 0.84rem !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px;
  white-space: nowrap;
  height: 44px !important;
  border-bottom: none !important;
}

.modern-table ::v-deep thead tr:not(.v-data-table__progress) th .v-icon {
  color: #ffffff !important;
}

.modern-table ::v-deep thead tr:not(.v-data-table__progress) th:hover {
  background-color: #333333 !important;
}

.modern-table ::v-deep thead tr.v-data-table__progress th {
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  height: auto !important;
}

.modern-table ::v-deep .v-data-table__empty-wrapper td {
  background: transparent !important;
  background-color: transparent !important;
}

.modern-table ::v-deep td {
  font-size: 0.85rem !important;
  padding: 10px 14px !important;
  border-bottom: 1px solid #f1f5f9 !important;
  vertical-align: middle;
}

.modern-table ::v-deep tbody tr:hover {
  background-color: #f8fafc !important;
  transition: background-color 0.15s ease-in-out;
}

.modern-table ::v-deep .v-data-footer {
  border-top: 1px solid #e2e8f0;
  background-color: #f8fafc;
  font-size: 0.82rem;
  padding: 8px 16px;
}

.table-responsive-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive-wrapper::-webkit-scrollbar {
  height: 6px;
}

.table-responsive-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.action-btn {
  transition: transform 0.18s ease-in-out, box-shadow 0.18s ease-in-out !important;
}

.action-btn:hover {
  transform: scale(1.1) !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2) !important;
}

.font-mono {
  font-family: monospace, "Courier New", Courier;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip ::v-deep .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}

.btn-circle-tooltip ::v-deep .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}
</style>
